import { $ } from 'src/shared/js/utils/dom';

const locator = $('.locator');
const uc = window.uc;
// If consent was given or revoked, a page reload is forced via js injected by typoscript (see packages/site_package/Configuration/TypoScript/Default/Page/Page.typoscript)

if (locator) {
  const mapConsentWasGiven = uc.getStatus('S1pcEj_jZX');
  const storeFinder = document.getElementById('store-finder-widget');
  const locatorIntro = document.getElementById('consent-map');
  if (locatorIntro) {
    const showMapLink = $('.btn--primary', locatorIntro);

    // directly opt-in to google maps:
    showMapLink.addEventListener('click', e => {
      e.preventDefault();
      // eslint-disable-next-line no-undef
      UC_UI.acceptService('S1pcEj_jZX');
    });
  }

  if (mapConsentWasGiven) {
    // init map view and hide locator intro
    const scriptTag = document.createElement('script');
    scriptTag.src =
      'https://static-prod.uberall.com/assets/storeFinderWidget-v2.js';
    scriptTag.async = true;
    scriptTag.onload = () => {
      window.UberallStorefinderStart();
    };
    document.head.appendChild(scriptTag);
    storeFinder && storeFinder.setAttribute('data-showbacklink', true);
    locatorIntro && locatorIntro.classList.add('is-hidden');
  } else {
    // init list view
    const scriptTag = document.createElement('script');
    scriptTag.src =
      'https://static-prod.uberall.com/assets/storeFinderWidget-v2-withoutMap.js';
    scriptTag.async = true;
    scriptTag.onload = () => {
      window.UberallStorefinderWithoutMapStart();
    };
    document.head.appendChild(scriptTag);
  }
}
